var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.08,
    height: 92.08,
    viewBox: "0 0 92.08 92.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 46.04,
    y1: 91.53,
    x2: 46.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0470e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14a0f8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.17,80.33c2.45,0,4.71,11.56,7.06,11.19a46,46,0,1,0-14.38,0C41.22,91.9,43.69,80.33,46.17,80.33Z",
    fillRule: "evenodd",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64,59.35,66,46H53.23V37.4c0-3.64,1.79-7.19,7.51-7.19h5.8V18.88a70.74,70.74,0,0,0-10.3-.9C45.72,18,38.85,24.36,38.85,35.9V46H27.16V59.35H38.85V91.52a46.44,46.44,0,0,0,14.38,0V59.35Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.99178f124fdd04c3c561822657e9deb9.svg";
export { ForwardRef as ReactComponent };